import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CookieService} from "ngx-cookie-service";
import {SessionManagerService} from "./session-manager.service";
import {Router} from "@angular/router";

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(
    private sessionManager: SessionManagerService,
    private router: Router,
    private cookies: CookieService
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // console.log(JSON.stringify(this.cookies.getAll()));
    // console.log(JSON.stringify(request.headers));

    if (request.url.startsWith("/assets")) {
      return next.handle(request)
    }

    let session = localStorage.getItem("session")
    // console.log("storage session", session)

    let stoken = localStorage.getItem("token")
    let ctoken = this.cookies.get("XSRF-TOKEN")

    // console.log("storage token", stoken)
    // console.log("cookies token", ctoken)

    if (ctoken === stoken) { // && stoken === htoken
      request = request.clone({
        withCredentials: true,
        setHeaders: { "X-XSRF-TOKEN": stoken }
      });
    } else {
      this.sessionManager.logout();
      this.router.navigate(["/signin"]);
    }

    return next.handle(request)
  }
}
